import { styled, css } from 'styled-components';

export const CardsSectionWrapper = styled.div<{ $inverted: boolean }>`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 96px 40px 48px 40px;
  background-color: ${({ theme, $inverted }) =>
    $inverted ? theme.colors.default[50] : 'transparent'};

  ${({ theme }) => theme.breakpoints.md.query} {
    padding: 96px 24px;
  }
`;

export const CardsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  flex-wrap: wrap;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
`;

export const CardsContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 48px 24px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  flex: 1 0 0;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    padding: 24px 0;
  }
`;

export const NumberedCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  padding: 48px 24px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex: 1 0 0;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.lg.query} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${({ theme }) => theme.breakpoints.sm.query} {
    grid-template-columns: repeat(1, 1fr);
    padding: 24px 12px;
  }
`;

export const ImageCard = styled.div<{ $altStyling?: boolean }>`
  display: flex;
  min-width: 320px;
  max-height: 288px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.default[100]};
  background: ${({ theme }) => theme.colors.base};
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  overflow: hidden;

  ${({ $altStyling, theme }) =>
    !$altStyling
      ? css`
          ${theme.breakpoints.lg.query} {
            min-width: 288px;
          }

          ${theme.breakpoints.md.query} {
            min-width: 100%;
            min-height: 288px;
          }

          ${theme.breakpoints.sm.query} {
            min-height: 250px;
          }
        `
      : css`
          width: 100%;
          height: 100%;
          min-height: revert;
          max-height: revert;
          min-width: revert;
          max-width: revert;
          overflow: visible;
          justify-content: flex-start;
        `}

  ${({ $altStyling, theme }) =>
    $altStyling &&
    css`
      flex-direction: row;
      padding: 24px;
      gap: 24px;

      ${ImageContainer} {
        height: 100%;
        width: 100%;
        max-width: max-content;
        min-width: max-content;
      }

      ${ImageCardTextContainer} {
        padding: 0;
        gap: 4px;

        > a {
        }
      }
    `}
`;

export const ImageCardTextContainer = styled.div`
  display: flex;
  padding: 0px 24px 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  overflow: hidden;
`;

export const Stat = styled.div`
  color: ${({ theme }) => theme.colors.primary.default};
`;

export const Card = styled.div`
  display: flex;
  width: 342px;
  padding: 48px 24px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.base};

  & span {
    color: ${({ theme }) => theme.colors.default[400]};
  }

  ${({ theme }) => theme.breakpoints.lg.query} {
    width: 280px;

    & > H4 {
      font-size: 16px;
    }
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;

    & > H6 {
      font-size: 19px;
    }
  }
`;

export const NumberedCard = styled.div`
  max-height: 437px;
  height: 100%;
  max-width: 310px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 0 0;
  border-radius: 16px;
  border: ${({ theme }) => `1px solid ${theme.colors.default[200]}`};
  background: ${({ theme }) => theme.colors.default[50]};
  margin: 0 auto;

  ${({ theme }) => theme.breakpoints.lg.query} {
    width: 100%;
  }
`;

export const NumberedCardTextContainer = styled.div`
  display: flex;
  padding: 32px 32px 16px 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  width: 100%;

  & > p {
    color: ${({ theme }) => theme.colors.default[400]};
    font-size: 16px;
  }
`;

export const Number = styled.div`
  font-size: 130px;
  color: ${({ theme }) => theme.colors.default[400]};
  height: 120px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-end;
`;
